export const translations = {
  header: {
    en: {
      home: 'Home',
      about: 'About Us',
      courses: 'Courses',
      whyUs: 'Why Choose Us',
      reviews: 'Reviews',
      gallery: 'Gallery',
      contact: 'Contact',
    },
    te: {
      home: 'హోమ్',
      about: 'మా గురించి',
      courses: 'కోర్సులు',
      whyUs: 'మమ్మల్ని ఎందుకు ఎంచుకోవాలి',
      reviews: 'సమీక్షలు',
      gallery: 'గ్యాలరీ',
      contact: 'సంప్రదించండి',
    },
  },
  hero: {
    en: {
      title: 'The Most Trusted Driving School in Tanuku',
      subtitle: 'Learn with Confidence & Safety',
      description: 'Professional training. Patient instructors. 100% confidence building.',
      enrollBtn: 'Enroll Now',
      callBtn: 'Call Now',
      directionsBtn: 'Get Directions',
      rating: '5.0 Star Rating',
      reviews: '448 Reviews',
    },
    te: {
      title: 'తణుకులో అత్యంత విశ్వసనీయ డ్రైవింగ్ పాఠశాల',
      subtitle: 'ఆత్మవిశ్వాసం & సురక్షతతో నేర్చుకోండి',
      description: 'వృత్తిపరమైన శిక్షణ. ఓపికగల శిక్షకులు. 100% విశ్వాసం నిర్మాణం.',
      enrollBtn: 'ఇప్పుడే నమోదు చేసుకోండి',
      callBtn: 'ఇప్పుడే కాల్ చేయండి',
      directionsBtn: 'దిశలను పొందండి',
      rating: '5.0 స్టార్ రేటింగ్',
      reviews: '448 సమీక్షలు',
    },
  },
  about: {
    en: {
      title: 'About Us',
      subtitle: 'Excellence in Driving Education',
      description: 'Tanuku Driving School has been a trusted name in driving education for years. Under the expert guidance of Suresh Garu, we have trained hundreds of students with patience, care, and professionalism.',
      instructor: 'Meet Your Instructor',
      instructorName: 'Suresh Garu',
      instructorDesc: 'Experienced, patient, and dedicated professional trainer committed to building your confidence and ensuring safe driving habits.',
      whyLearn: 'Why Learn with Us',
      points: [
        'Years of teaching experience',
        'Patient and calm teaching style',
        'Individual attention to each student',
        'Confidence-building approach',
        'Focus on safe driving & traffic discipline',
        'Flexible timings for working professionals',
      ],
    },
    te: {
      title: 'మా గురించి',
      subtitle: 'డ్రైవింగ్ విద్యలో శ్రేష్ఠత',
      description: 'తణుకు డ్రైవింగ్ పాఠశాల సంవత్సరాలుగా డ్రైవింగ్ విద్యలో విశ్వసనీయ పేరు. సురేష్ గారి నిపుణుల మార్గదర్శకత్వంలో, మేము వందలాది మంది విద్యార్థులకు ఓపిక, శ్రద్ధ మరియు వృత్తి నైపుణ్యంతో శిక్షణ ఇచ్చాము.',
      instructor: 'మీ శిక్షకుడిని కలవండి',
      instructorName: 'సురేష్ గారు',
      instructorDesc: 'అనుభవజ్ఞుడు, ఓపికగల మరియు అంకితభావం కలిగిన వృత్తిపరమైన శిక్షకుడు మీ ఆత్మవిశ్వాసాన్ని పెంచడానికి మరియు సురక్షితమైన డ్రైవింగ్ అలవాట్లను నిర్ధారించడానికి కట్టుబడి ఉన్నారు.',
      whyLearn: 'మాతో ఏమి నేర్చుకోవాలి',
      points: [
        'సంవత్సరాల బోధనా అనుభవం',
        'ఓపికగల మరియు ప్రశాంతమైన బోధనా శైలి',
        'ప్రతి విద్యార్థికి వ్యక్తిగత శ్రద్ధ',
        'విశ్వాస-నిర్మాణ విధానం',
        'సురక్షిత డ్రైవింగ్ & ట్రాఫిక్ క్రమశిక్షణపై దృష్టి',
        'ఉద్యోగ నిపుణులకు అనువైన సమయాలు',
      ],
    },
  },
  courses: {
    en: {
      title: 'Our Courses',
      subtitle: 'Comprehensive Training Programs',
      list: [
        {
          name: 'Beginner Car Driving',
          description: 'Perfect for first-time learners. Start from basics and build confidence step by step.',
          duration: '15-20 Days',
          icon: 'car',
        },
        {
          name: 'Advanced Driving',
          description: 'Master advanced techniques including highway driving, parking, and defensive driving.',
          duration: '10-15 Days',
          icon: 'gauge',
        },
        {
          name: 'Traffic & Road Safety',
          description: 'Learn traffic rules, road signs, and safety measures for responsible driving.',
          duration: '5-7 Days',
          icon: 'traffic-cone',
        },
        {
          name: 'Confidence Building',
          description: 'Special training for nervous drivers to overcome fear and drive confidently.',
          duration: 'As Needed',
          icon: 'shield-check',
        },
        {
          name: 'Manual & Automatic',
          description: 'Training available for both manual and automatic transmission vehicles.',
          duration: 'Flexible',
          icon: 'settings',
        },
        {
          name: 'Flexible Timings',
          description: 'Morning and evening batches available. We work around your schedule.',
          duration: 'Your Choice',
          icon: 'clock',
        },
      ],
    },
    te: {
      title: 'మా కోర్సులు',
      subtitle: 'సమగ్ర శిక్షణ కార్యక్రమాలు',
      list: [
        {
          name: 'ప్రారంభ కార్ డ్రైవింగ్',
          description: 'మొదటి సారి నేర్చుకునే వారికి సరైనది. ప్రాథమికాల నుండి ప్రారంభించి దశలవారీగా విశ్వాసాన్ని పెంచుకోండి.',
          duration: '15-20 రోజులు',
          icon: 'car',
        },
        {
          name: 'అధునాతన డ్రైవింగ్',
          description: 'హైవే డ్రైవింగ్, పార్కింగ్ మరియు రక్షణాత్మక డ్రైవింగ్ తో సహా అధునాతన పద్ధతులను నేర్చుకోండి.',
          duration: '10-15 రోజులు',
          icon: 'gauge',
        },
        {
          name: 'ట్రాఫిక్ & రహదారి భద్రత',
          description: 'బాధ్యతాయుతమైన డ్రైవింగ్ కోసం ట్రాఫిక్ నియమాలు, రహదారి గుర్తులు మరియు భద్రతా చర్యలను నేర్చుకోండి.',
          duration: '5-7 రోజులు',
          icon: 'traffic-cone',
        },
        {
          name: 'విశ్వాస నిర్మాణం',
          description: 'భయాన్ని అధిగమించి ఆత్మవిశ్వాసంతో డ్రైవ్ చేయడానికి నాడీ డ్రైవర్లకు ప్రత్యేక శిక్షణ.',
          duration: 'అవసరం ప్రకారం',
          icon: 'shield-check',
        },
        {
          name: 'మాన్యువల్ & ఆటోమేటిక్',
          description: 'మాన్యువల్ మరియు ఆటోమేటిక్ ట్రాన్స్మిషన్ వాహనాల కోసం శిక్షణ అందుబాటులో ఉంది.',
          duration: 'అనువైన',
          icon: 'settings',
        },
        {
          name: 'అనువైన సమయాలు',
          description: 'ఉదయం మరియు సాయంత్రం బ్యాచ్‌లు అందుబాటులో ఉన్నాయి. మేము మీ షెడ్యూల్ చుట్టూ పనిచేస్తాము.',
          duration: 'మీ ఎంపిక',
          icon: 'clock',
        },
      ],
    },
  },
  whyUs: {
    en: {
      title: 'Why Choose Us',
      subtitle: 'What Makes Us Different',
      features: [
        {
          title: '5.0 Star Rating',
          description: '448+ genuine Google reviews from satisfied students',
          icon: 'star',
        },
        {
          title: 'Patient Teaching',
          description: 'Calm and polite instruction style, perfect for beginners',
          icon: 'heart',
        },
        {
          title: 'Step-by-Step Learning',
          description: 'Clear explanations and gradual progression at your pace',
          icon: 'layers',
        },
        {
          title: 'Safe Environment',
          description: 'Learn in a stress-free, supportive atmosphere',
          icon: 'shield',
        },
        {
          title: 'Flexible Timings',
          description: 'Morning and evening slots to fit your schedule',
          icon: 'calendar',
        },
        {
          title: 'For Everyone',
          description: 'Suitable for beginners, women, and working professionals',
          icon: 'users',
        },
      ],
    },
    te: {
      title: 'మమ్మల్ని ఎందుకు ఎంచుకోవాలి',
      subtitle: 'మాకు ప్రత్యేకత ఏమిటి',
      features: [
        {
          title: '5.0 స్టార్ రేటింగ్',
          description: 'సంతృప్తి చెందిన విద్యార్థుల నుండి 448+ నిజమైన గూగుల్ సమీక్షలు',
          icon: 'star',
        },
        {
          title: 'ఓపికగల బోధన',
          description: 'ప్రశాంతమైన మరియు మర్యాదపూర్వకమైన బోధనా శైలి, ప్రారంభకులకు సరైనది',
          icon: 'heart',
        },
        {
          title: 'దశలవారీ అభ్యాసం',
          description: 'స్పష్టమైన వివరణలు మరియు మీ వేగంతో క్రమంగా పురోగతి',
          icon: 'layers',
        },
        {
          title: 'సురక్షిత వాతావరణం',
          description: 'ఒత్తిడి-రహిత, సహాయక వాతావరణంలో నేర్చుకోండి',
          icon: 'shield',
        },
        {
          title: 'అనువైన సమయాలు',
          description: 'మీ షెడ్యూల్‌కు సరిపోయేలా ఉదయం మరియు సాయంత్రం స్లాట్‌లు',
          icon: 'calendar',
        },
        {
          title: 'అందరికీ',
          description: 'ప్రారంభకులు, మహిళలు మరియు ఉద్యోగ నిపుణులకు అనుకూలం',
          icon: 'users',
        },
      ],
    },
  },
  reviews: {
    en: {
      title: 'Student Reviews',
      subtitle: 'What Our Students Say',
      testimonials: [
        {
          name: 'Rajesh Kumar',
          rating: 5,
          text: 'Suresh Garu is very patient and explains everything clearly. I was nervous at first but he made me feel comfortable. Best driving school in Tanuku!',
        },
        {
          name: 'Priya Reddy',
          rating: 5,
          text: 'Excellent instructor! Very polite and gives step-by-step instructions. I learned to drive confidently within 3 weeks. Highly recommended.',
        },
        {
          name: 'Venkat Rao',
          rating: 5,
          text: 'Good explanation and patient teaching. Perfect for beginners. The timings are also very flexible which helped me a lot.',
        },
        {
          name: 'Lakshmi Devi',
          rating: 5,
          text: 'I was very scared to learn driving but Suresh Garu made it so easy. He is very calm and supportive. Thank you so much!',
        },
        {
          name: 'Srinivas Murthy',
          rating: 5,
          text: 'Professional training with focus on safety. Learned both theory and practical very well. Worth every rupee spent.',
        },
        {
          name: 'Anitha Sharma',
          rating: 5,
          text: 'Best driving instructor in Tanuku! Very patient with women learners. My confidence has increased a lot. Strongly recommend.',
        },
      ],
    },
    te: {
      title: 'విద్యార్థుల సమీక్షలు',
      subtitle: 'మా విద్యార్థులు ఏమి చెబుతున్నారు',
      testimonials: [
        {
          name: 'రాజేష్ కుమార్',
          rating: 5,
          text: 'సురేష్ గారు చాలా ఓపికగా ఉంటారు మరియు ప్రతిదీ స్పష్టంగా వివరిస్తారు. నేను మొదట్లో భయపడ్డాను కానీ అతను నాకు సౌకర్యంగా ఉండేలా చేశారు. తణుకులో ఉత్తమ డ్రైవింగ్ పాఠశాల!',
        },
        {
          name: 'ప్రియ రెడ్డి',
          rating: 5,
          text: 'అద్భుతమైన శిక్షకుడు! చాలా మర్యాదగా ఉంటారు మరియు దశలవారీ సూచనలు ఇస్తారు. నేను 3 వారాల్లో ఆత్మవిశ్వాసంతో డ్రైవ్ చేయడం నేర్చుకున్నాను. చాలా సిఫార్సు చేయబడింది.',
        },
        {
          name: 'వెంకట్ రావు',
          rating: 5,
          text: 'మంచి వివరణ మరియు ఓపికగల బోధన. ప్రారంభకులకు సరైనది. సమయాలు కూడా చాలా అనువైనవి, ఇది నాకు చాలా సహాయపడింది.',
        },
        {
          name: 'లక్ష్మీదేవి',
          rating: 5,
          text: 'నేను డ్రైవింగ్ నేర్చుకోవడానికి చాలా భయపడ్డాను కానీ సురేష్ గారు చాలా సులభంగా చేశారు. అతను చాలా ప్రశాంతంగా మరియు సహాయకారిగా ఉన్నారు. చాలా ధన్యవాదాలు!',
        },
        {
          name: 'శ్రీనివాస్ మూర్తి',
          rating: 5,
          text: 'భద్రతపై దృష్టి కేంద్రీకరించిన వృత్తిపరమైన శిక్షణ. సిద్ధాంతం మరియు ఆచరణాత్మకం రెండూ బాగా నేర్చుకున్నాను. ఖర్చు చేసిన ప్రతి రూపాయికి విలువైనది.',
        },
        {
          name: 'అనిత శర్మ',
          rating: 5,
          text: 'తణుకులో ఉత్తమ డ్రైవింగ్ శిక్షకుడు! మహిళా అభ్యాసకులతో చాలా ఓపికగా ఉంటారు. నా విశ్వాసం చాలా పెరిగింది. బలంగా సిఫార్సు చేస్తున్నాను.',
        },
      ],
    },
  },
  gallery: {
    en: {
      title: 'Gallery',
      subtitle: 'Our Training in Action',
    },
    te: {
      title: 'గ్యాలరీ',
      subtitle: 'మా శిక్షణ చర్యలో',
    },
  },
  contact: {
    en: {
      title: 'Contact Us',
      subtitle: 'Get in Touch',
      phone: 'Phone',
      address: 'Address',
      hours: 'Open Hours',
      addressText: 'RCC building, opposite Sivalayam Street, Housing Board Colony, Sajjapuram, Andhra Pradesh 534211',
      hoursText: '5:00 AM – 9:00 PM (All Days)',
      formTitle: 'Send us a Message',
      name: 'Your Name',
      email: 'Your Email',
      message: 'Your Message',
      submit: 'Send Message',
      whatsapp: 'WhatsApp',
      call: 'Call Now',
    },
    te: {
      title: 'సంప్రదించండి',
      subtitle: 'మాతో సంప్రదించండి',
      phone: 'ఫోన్',
      address: 'చిరునామా',
      hours: 'తెరిచే గంటలు',
      addressText: 'RCC భవనం, శివాలయం వీధికి ఎదురుగా, హౌసింగ్ బోర్డ్ కాలనీ, సజ్జాపురం, ఆంధ్రప్రదేశ్ 534211',
      hoursText: '5:00 AM – 9:00 PM (అన్ని రోజులు)',
      formTitle: 'మాకు సందేశం పంపండి',
      name: 'మీ పేరు',
      email: 'మీ ఇమెయిల్',
      message: 'మీ సందేశం',
      submit: 'సందేశం పంపండి',
      whatsapp: 'వాట్సాప్',
      call: 'ఇప్పుడే కాల్ చేయండి',
    },
  },
  footer: {
    en: {
      tagline: 'Learn to drive with confidence and safety',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      copyright: '© 2025 Tanuku Driving School. All rights reserved.',
    },
    te: {
      tagline: 'ఆత్మవిశ్వాసం మరియు భద్రతతో డ్రైవ్ చేయడం నేర్చుకోండి',
      quickLinks: 'శీఘ్ర లింక్‌లు',
      followUs: 'మమ్మల్ని అనుసరించండి',
      copyright: '© 2025 తణుకు డ్రైవింగ్ పాఠశాల. అన్ని హక్కులు రక్షించబడ్డాయి.',
    },
  },
};

export const contactInfo = {
  phone: '+91 70753 47186',
  address: 'RCC building, opposite Sivalayam Street, Housing Board Colony, Sajjapuram, Andhra Pradesh 534211',
  mapUrl: 'https://www.google.com/maps/place/Tanuku+Driving+school/@16.7608791,81.6798097',
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3830.1111111111!2d81.6798097!3d16.7608791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37b73cc46878a9%3A0x9e5491d10f2ec76d!2sTanuku%20Driving%20school!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin',
  rating: '5.0',
  totalReviews: 448,
  hours: '5:00 AM – 9:00 PM',
  whatsappUrl: 'https://wa.me/917075347186',
};

export const galleryImages = [
  {
    url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzfe9HVyLdCrVzph2bNtyh-rnLS_VxZYHDEXz0FtEKIeOLqFZh5FXICYq9tRHffuPH714sYNTS3NO1lWHhC70HShkIQkRylYaqgowEfWxAXgtV6_3f4J85k6TE05opo7n1e9P8w=w800',
    alt: 'Tanuku Driving School Training',
  },
  {
    url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzfe9HVyLdCrVzph2bNtyh-rnLS_VxZYHDEXz0FtEKIeOLqFZh5FXICYq9tRHffuPH714sYNTS3NO1lWHhC70HShkIQkRylYaqgowEfWxAXgtV6_3f4J85k6TE05opo7n1e9P8w=w800',
    alt: 'Student Learning to Drive',
  },
  {
    url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzfe9HVyLdCrVzph2bNtyh-rnLS_VxZYHDEXz0FtEKIeOLqFZh5FXICYq9tRHffuPH714sYNTS3NO1lWHhC70HShkIQkRylYaqgowEfWxAXgtV6_3f4J85k6TE05opo7n1e9P8w=w800',
    alt: 'Professional Driving Instruction',
  },
  {
    url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzfe9HVyLdCrVzph2bNtyh-rnLS_VxZYHDEXz0FtEKIeOLqFZh5FXICYq9tRHffuPH714sYNTS3NO1lWHhC70HShkIQkRylYaqgowEfWxAXgtV6_3f4J85k6TE05opo7n1e9P8w=w800',
    alt: 'Road Safety Training',
  },
];
